import { createSlice } from '@reduxjs/toolkit';

export const imageModalSlice = createSlice({
  name: 'imageModal',
  initialState: {
    singleImageData: {},
    isOpenShareFeedbackModal: false,
    isShareFeedbackSuccess: false,
    isOpenShareFeedbackSuccessModal: false,
    isOpenViewDetailsModal: false,
    isOpenDownloadImageModal: false,
    isOpenTermsAndConditionsModal: false,
  },
  reducers: {
    setSingleImageData: (state, action) => {
      state.singleImageData = action.payload;
    },
    setIsOpenShareFeedbackModal: (state, action) => {
      state.isOpenShareFeedbackModal = action.payload;
    },
    setIsShareFeedbackSuccess: (state, action) => {
      state.isShareFeedbackSuccess = action.payload;
    },
    setIsOpenShareFeedbackSuccessModal: (state, action) => {
      state.isOpenShareFeedbackSuccessModal = action.payload;
    },
    setIsOpenViewDetailsModal: (state, action) => {
      state.isOpenViewDetailsModal = action.payload;
    },
    setDownloadImageModal: (state, action) => {
      state.isOpenDownloadImageModal = action.payload;
    },
    setIsOpenTermsAndConditionsModal: (state, action) => {
      state.isOpenTermsAndConditionsModal = action.payload;
    },
    updateSingleImageRating: (state, action) => {
      const { rating, comment } = action.payload;
      state.singleImageData.rating = rating;
      state.singleImageData.comment = comment;
    }
  },
});

export const {
  setSingleImageData,
  setIsOpenShareFeedbackModal,
  setIsShareFeedbackSuccess,
  setIsOpenShareFeedbackSuccessModal,
  setIsOpenViewDetailsModal,
  setDownloadImageModal,
  setIsOpenTermsAndConditionsModal,
  updateSingleImageRating
} = imageModalSlice.actions;

export default imageModalSlice.reducer;